import script from "./DBPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DBPage.vue?vue&type=script&setup=true&lang=js"

import "./DBPage.vue?vue&type=style&index=0&id=6b8f273b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8f273b"]])

export default __exports__